exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".store-list{width:100%;height:100%;overflow-y:auto;border:1px solid #e0e0e0;border-radius:4px}", ""]);

// exports
